import React from 'react'
import { history } from '../store'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { passwordRecoveryClientEmail } from '../actions/auth'

const STYLES = `
.lv-wrap{display:flex;min-height:100vh;background:url(/images/login_bg.png) center/cover no-repeat;position:relative}
.lv-wrap::before{content:'';position:absolute;inset:0;pointer-events:none}
.lv-hero{flex:1;position:sticky;top:0;height:100vh;display:flex;align-items:center;justify-content:center;padding:40px;z-index:1}
.lv-hero img{max-width:480px;width:100%;opacity:.9}
.lv-panel{width:480px;min-height:100vh;background:rgba(0,18,40,.50);backdrop-filter:blur(14px);border-left:1px solid rgba(255,255,255,.12);display:flex;flex-direction:column;align-items:center;justify-content:center;padding:48px 40px;overflow-y:auto;position:relative;z-index:1}
.lv-logo{height:42px;margin-bottom:8px}
.lv-title{color:#fff;font-size:22px;font-weight:700;letter-spacing:4px;margin-bottom:24px}
.lv-subtitle{color:rgba(255,255,255,.85);font-size:13px;text-align:center;margin-bottom:24px;line-height:1.6}
.lv-form{width:100%}
.lv-field{margin-bottom:16px}
.lv-label{display:block;color:rgba(255,255,255,.7);font-size:13px;margin-bottom:6px}
.lv-input{width:100%;padding:11px 14px;border-radius:10px;border:1.5px solid rgba(255,255,255,.15);background:rgba(255,255,255,.08);color:#fff;font-size:14px;outline:none;box-sizing:border-box;transition:border-color .2s}
.lv-input::placeholder{color:rgba(255,255,255,.35)}
.lv-input:focus{border-color:rgba(255,255,255,.5)}
.lv-btn{width:100%;padding:13px;border-radius:40px;border:none;background:#fff;color:#001830;font-weight:700;font-size:15px;cursor:pointer;transition:opacity .2s;margin-top:8px}
.lv-btn:disabled{opacity:.5;cursor:not-allowed}
.lv-err{background:rgba(248,113,113,.15);border:1px solid rgba(248,113,113,.4);color:#fca5a5;padding:10px 14px;border-radius:8px;font-size:13px;margin-top:12px}
.lv-ok{background:rgba(74,222,128,.12);border:1px solid rgba(74,222,128,.35);color:rgba(255,255,255,.7);padding:14px 16px;border-radius:8px;font-size:13px;line-height:1.6;text-align:center;margin-bottom:16px}
.lv-link{color:rgba(255,255,255,.55);font-size:12px;text-align:center;margin-top:14px;cursor:pointer;text-decoration:underline}
@media(max-width:820px){.lv-hero{display:none}.lv-panel{width:100%;border-left:none;padding:32px 24px}}
`

class PasswordRecoveryClientView extends React.Component {
  constructor(props) {
    super(props)
    this.state = { email: '', error: '', loading: false, success: false }
  }

  componentDidMount() {
    if (!document.getElementById('lv-styles-recovery')) {
      const s = document.createElement('style'); s.id = 'lv-styles-recovery'; s.textContent = STYLES; document.head.appendChild(s)
    }
  }

  async handleSubmit(e) {
    e.preventDefault()
    const { email } = this.state
    if (!email) { this.setState({ error: 'El email es obligatorio.' }); return }
    this.setState({ loading: true, error: '' })
    const result = await this.props.passwordRecoveryClientEmail({ email })
    if (result && result.error) {
      this.setState({ error: result.error.message || 'Error al procesar la solicitud.', loading: false })
    } else {
      this.setState({ success: true, loading: false })
    }
  }

  render() {
    const { email, error, loading, success } = this.state
    return (
      <div className="lv-wrap">
        <div className="lv-hero">
          <img src="/images/one_render.png" alt="VACWAY ONE" />
        </div>
        <div className="lv-panel">
          <img className="lv-logo" src="/images/logo.svg" alt="VACWAY ONE" />
          <div className="lv-title">WATERPROOF</div>
          {success ? (
            <>
              <div className="lv-ok">
                Hemos enviado un correo al email facilitado.<br />
                Sigue los pasos para recuperar la contraseña.
              </div>
              <button className="lv-btn" onClick={() => history.push('/')}>Volver al inicio</button>
            </>
          ) : (
            <>
              <div className="lv-subtitle">Introduce tu email y te enviaremos instrucciones para restablecer tu contraseña.</div>
              <form className="lv-form" onSubmit={e => this.handleSubmit(e)}>
                <div className="lv-field">
                  <label className="lv-label">Email</label>
                  <input className="lv-input" type="email" value={email} autoComplete="email"
                    placeholder="tu@email.com" onChange={e => this.setState({ email: e.target.value })} />
                </div>
                {error && <div className="lv-err">{error}</div>}
                <button className="lv-btn" type="submit" disabled={loading}>
                  {loading ? 'Enviando...' : 'Enviar instrucciones'}
                </button>
                <div className="lv-link" style={{ marginTop: 16 }} onClick={() => history.push('/')}>← Volver al inicio</div>
              </form>
            </>
          )}
        </div>
      </div>
    )
  }
}

const mapDispatchToProps = dispatch => ({
  passwordRecoveryClientEmail: bindActionCreators(passwordRecoveryClientEmail, dispatch)
})

export default connect(() => ({}), mapDispatchToProps)(PasswordRecoveryClientView)
